<template>
  <table>
    <tbody v-for="orderInfo in orderInfoList" :key="orderInfo.id">
    <tr>
      <th><p>{{ orderInfo.goodsName }}</p></th>
      <td>{{ orderInfo.priceInfo.origin_price | numberFormat }} 원</td>
    </tr>
    <tr class="add_price emphasize"
        v-for="(disCountInfo, index) in orderInfo.discount"
        v-show="disCountInfo.sub_price"
        :key="index">
      <th>
        <span>└ {{ disCountInfo.rule_name }}</span>
        <span v-html="$options.filters.discountDetailHtml(disCountInfo.display_value)"></span>
      </th>
      <td><span>- {{ disCountInfo.sub_price | numberFormat }} 원</span></td>
    </tr>
    
    <!-- 설치비 -->
    <tr class="add_price"
        v-if="orderInfo.priceInfo.installation_cost && orderInfo.priceInfo.installation_cost.price">
      <th><p>└ 설치비</p></th>
      <td><span>{{ orderInfo.priceInfo.installation_cost.price | numberFormat }} 원</span></td>
    </tr>

    <!-- 설치비의 할인(도메인) -->
    <tr class="add_price emphasize"
        v-for="(discountRuleInfo, index) in getInstallationDiscountRuleInfoFromOrderInfo(orderInfo)"
        :key="index+1">
      <th><p>└ {{discountRuleInfo.rule_name}} ({{discountRuleInfo.display_value}})</p></th>
      <td><span>{{ discountRuleInfo.sub_price | numberFormat }} 원</span></td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: "MainGoodsCalculate",
  computed: {
    ...mapGetters({
      orderInfoList : 'order_info/getOrderInfoList',
    })
  },
  methods: {
    getInstallationDiscountRuleInfoFromOrderInfo(orderInfo){
      if(!orderInfo.priceInfo.installation_cost){
        return []
      }
      if(!orderInfo.priceInfo.installation_cost.price){
        return []
      }
      if(!orderInfo.priceInfo.installation_cost.discount_rule){
        return []
      }
      return orderInfo.priceInfo.installation_cost.discount_rule
    }
  }
}
</script>

<style scoped>

</style>